import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup.object({
    claimsStatus: yup.bool().typeError(
      formatMessage({
        id: 'FIELD_CLAIMSSTATUS_REQUIRED_LABEL',
        defaultMessage: 'Claims Status is required',
      }),
    ),
  });

export default validationSchema;
